export default class CountryComponent {

    constructor(selector, matrix, deliveryMethods, paymentMethods, countryComponentStep2, val) {

        this.selector = selector;
        this.deliveryMethods = deliveryMethods;
        this.paymentMethods = paymentMethods;
        this.matrix = matrix;
        this.country = 'PL';
        this.step2CountryComponent = countryComponentStep2;
        this.val = val;

        this.initEvents();
    }

    initEvents() {
        this.selector.on('change', e => this.countryChanged())
    }

    countryChanged() {
        let country = this.selector.find('option:selected').val();

        this.step2CountryComponent.setActiveCountry(country,this.selector.find('option:selected').text());

        this.updateDeliveryMethods(country);
        this.updatePaymentMethods(country);
    }

    updateDeliveryMethods(country) {
        let deliveryMethods = this.matrix.getDeliveryMethodsByCountry(country);

        this.deliveryMethods.each(function(index,delivery) {
            if(deliveryMethods.indexOf(delivery.value) !== -1) {
                $(this).parent().parent().removeClass('hidden');
                $(this).prop('checked', false);
            }
            else {
                $(this).parent().parent().addClass('hidden');
            }
        });
    }

    updatePaymentMethods() {
        let paymentMethods  = this.matrix.getAvailablePaymentMethods();

        if(paymentMethods === undefined) {
            return ;
        }

        this.paymentMethods.each(function(index, payment) {
            if(paymentMethods.indexOf(parseInt(payment.value)) !== -1) {
                $(this).parent().parent().removeClass('hidden');
                $(this).prop('checked', false);
            }
            else {
                $(this).parent().parent().addClass('hidden');
            }
        });

    }
}
